import React from 'react';
import { Box, Drawer, IconButton } from '@chakra-ui/react';
import { FiX } from 'react-icons/fi';
import MobileMainMenu from './MobileMainMenu';
import MobileSubmenu from './MobileSubmenu';

interface MobileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileDrawer: React.FC<MobileDrawerProps> = ({ isOpen, onClose }) => {
  const [activeSubmenu, setActiveSubmenu] = React.useState<'top-features' | 'learn-more' | null>(null);
  const touchStartYRef = React.useRef<number | null>(null);

  React.useEffect(() => {
    if (!isOpen) {
      const timeout = setTimeout(() => setActiveSubmenu(null), 300);
      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  const handleTouchStart: React.TouchEventHandler = (event) => {
    const firstTouch = event.touches[0];
    touchStartYRef.current = firstTouch?.clientY ?? null;
  };

  const handleTouchEnd: React.TouchEventHandler = (event) => {
    const startY = touchStartYRef.current;
    touchStartYRef.current = null;
    if (startY == null) return;
    const endY = event.changedTouches[0]?.clientY ?? startY;
    const deltaY = endY - startY;
    const swipeToCloseThresholdPx = 60;
    if (deltaY < -swipeToCloseThresholdPx) {
      onClose();
    }
  };

  return (
    <Drawer.Root
      open={isOpen}
      onOpenChange={(details) => {
        if (!details.open) onClose();
      }}
      placement="top"
    >
      <Drawer.Backdrop />
      <Drawer.Positioner>
        <Drawer.Content
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          style={{
            borderBottomLeftRadius: '15px',
            borderBottomRightRadius: '15px',
            height: 'auto',
            maxHeight: '85vh',
          }}
          backgroundColor="white"
          role="dialog"
          aria-modal="true"
          aria-label="Mobile navigation menu"
        >
          <Drawer.Header>
            <Drawer.CloseTrigger asChild>
              <IconButton color="#13131B" aria-label="Close menu" variant="ghost">
                <FiX />
              </IconButton>
            </Drawer.CloseTrigger>
          </Drawer.Header>
          <Drawer.Body p={0} overflow="hidden">
            <Box position="relative" width="100%" overflow="hidden">
              <MobileMainMenu
                isVisible={activeSubmenu === null}
                onOpenSubmenu={setActiveSubmenu}
                onCloseMenu={onClose}
              />
              <MobileSubmenu
                activeMenu={activeSubmenu}
                onBack={() => setActiveSubmenu(null)}
                onCloseDrawer={onClose}
              />
            </Box>
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
};

export default MobileDrawer;
